import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { useDebounce } from "./utils";


export function useUrlQuerySearch(key : string = "q") {
    const [searchParams, setSearchParams] = useSearchParams();
    
    const urlQ = searchParams.get(key) || '';
    const [inputQ, _setInputQ] = useState(urlQ);
    const [inputEdited, setInputEdited] = useState(false);
    const debouncedInputQ = useDebounce(inputQ.replace(/\s+/g, " ").trim(), 500);

    useEffect(() => {
        if (debouncedInputQ != urlQ) {
            setSearchParams(prev => {
                if (debouncedInputQ)
                    prev.set(key, debouncedInputQ);
                else 
                    prev.delete(key)
                return prev;
            });
        }
    }, [debouncedInputQ]);
    useEffect(() => {
        if (!inputEdited) {
            _setInputQ(urlQ);
        } else if (inputQ == urlQ) {
            setInputEdited(false);
        }
    }, [urlQ, inputEdited]);

    const setInputQ = useCallback((v : string) => {
        setInputEdited(true);
        _setInputQ(v);
    }, [_setInputQ, setInputEdited])

    return {
        q: urlQ,
        inputQ,
        setInputQ,
        inputEdited
    }

}